import React from 'react';
import { Body } from '@hover/blueprint';
import { TRUST_CENTER_HEADER_DESCRIPTION } from '../../constants';
import { SharedFaq } from '../common';

const Description: React.FC = () => (
  <>
    <Body mb={600}>
      At HOVER, we are on a mission to organize the world’s physical structure
      and we are a trusted provider for homeowners, our customers, and within
      our partner ecosystem. To do this, we commit to communicate transparently,
      provide security, and protect the privacy of the data within HOVER’s
      systems.
    </Body>
    <SharedFaq questions={TRUST_CENTER_HEADER_DESCRIPTION} />
  </>
);

export default Description;
